<template>
  <v-container fluid>
    <v-row>
      <v-col class="text-h3 gray--text"> Histórico Familiar </v-col>
      <v-col cols="auto" class="mt-2">
        <SaveStatus
          :saving="saveManager.isSaving"
          :pending="saveManager.pendingSave"
          :saved-at="familyHistory.updatedAt"
          :error="hasErrors || saveManager.isError"
          :loading="isLoading"
          not-saved-message="O H.F. ainda não foi salvo."
        />
      </v-col>
      <v-col cols="auto">
        <v-btn
          color="light-blue"
          dark
          @click="saveManager.triggerManualSave()"
          :loading="isLoading || saveManager.isSaving"
          :disabled="attendanceEsigned"
        >
          Salvar H.F.
        </v-btn>
      </v-col>
    </v-row>
    <MedicalRecordHfSkeletonLoader v-if="isLoading" />
    <v-row v-else>
      <v-col>
        <v-row dense>
          <v-col>
            <v-combobox
              v-model="facilitator"
              outlined
              dense
              hide-details
              label="Presença de"
              :items="facilitator_presence_of"
              @change="handleFacilitatorChange"
              background-color="white"
              :disabled="attendanceEsigned"
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-combobox
              v-model="facilitator"
              outlined
              dense
              hide-details
              label="Patologia"
              :items="facilitator_pathology"
              @change="handleFacilitatorChange"
              background-color="white"
              :disabled="attendanceEsigned"
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-combobox
              v-model="facilitator"
              outlined
              dense
              hide-details
              label="Parente"
              :items="facilitator_relative"
              @change="handleFacilitatorChange"
              background-color="white"
              :disabled="attendanceEsigned"
            />
          </v-col>
        </v-row>
      </v-col>

      <v-col>
        <v-row dense>
          <v-col>
            <v-textarea
              v-model="familyHistory.description"
              v-uppercase
              solo
              dense
              rows="6"
              placeholder="Digite o histórico familiar..."
              background-color="white"
              :hide-details="!hasErrors"
              :error-messages="errors.description"
              :disabled="attendanceEsigned"
              @input="handleFormChange"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import GET_FAMILY_HISTORY_FACILITATORS from "@/graphql/family_history_facilitators.gql";
import GET_FAMILY_HISTORY from "@/graphql/family_history.gql";
import SAVE_FAMILY_HISTORY from "@/graphql/save_family_history.gql";

import MedicalRecordHfSkeletonLoader from "@/components/medical_record/hf/skeleton_loader.vue";
import SaveStatus from "@/components/ui/form/save_status/index.vue";

import { AutoSaveManager } from "@/services/AutoSaveManager/index.js";

export default {
  name: "HF",
  components: { MedicalRecordHfSkeletonLoader, SaveStatus },
  props: {
    attendance: Object,
    attendanceEsigned: Boolean,
  },
  data() {
    return {
      familyHistoryFacilitators: [],
      familyHistory: {},
      facilitator: [],
      errors: {},
      saveManager: null,
    };
  },
  apollo: {
    familyHistoryFacilitators: {
      query: GET_FAMILY_HISTORY_FACILITATORS,
    },
    familyHistory: {
      query: GET_FAMILY_HISTORY,
      fetchPolicy: "no-cache",
      variables() {
        return {
          attendanceId: this.attendance.id,
        };
      },
    },
  },
  created() {
    this.saveManager = new AutoSaveManager({
      formName: "H.F",
      beforeSave: () => this.beforeSave(),
      onSave: () => this.onSave(),
    });
  },
  watch: {
    $route() {
      this.saveFamilyHistory();
    },
  },
  computed: {
    isLoading(){
      if(this.$apollo.queries.familyHistoryFacilitators.loading){
        return true
      }

      return !this.familyHistory.id;
    },
    facilitator_presence_of() {
      return this.lodash.filter(this.orderedfacilitators, {
        facilitatorType: "presence_of",
      });
    },
    facilitator_pathology() {
      return this.lodash.filter(this.orderedfacilitators, {
        facilitatorType: "pathology",
      });
    },
    facilitator_relative() {
      return this.lodash.filter(this.orderedfacilitators, {
        facilitatorType: "relative",
      });
    },
    orderedfacilitators() {
      return this.lodash.orderBy(
        this.familyHistoryFacilitators,
        [(e) => e.text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "")],
        ["asc"]
      );
    },
    hasErrors() {
      return Object.keys(this.errors).length > 0;
    },
  },
  methods: {
    handleFacilitatorChange(e) {
      if (this.attendanceEsigned) return;

      if (e) {
        if (this.familyHistory.description !== null) {
          this.familyHistory.description += ` ${e.text}`;
          this.familyHistory.description = this.familyHistory.description.trim();
        } else {
          this.familyHistory.description = ` ${e.text}`;
        }
      }

      this.facilitator = [];
      this.handleFormChange();
    },
    handleFormChange() {
      this.saveManager.dispatchAutoSave();
    },
    beforeSave() {
      this.validateForm();

     if(this.hasErrors) return false;
     if(this.attendanceEsigned) return false;

     return true;
    },
    async onSave(){
      let description = this.familyHistory.description;

      if(description == null){
        description = ""
      }

      const { data } = await this.apolloMutate({
        mutation: SAVE_FAMILY_HISTORY,
        variables: {
          attendanceId: this.attendance.id,
          description: description,
        },
      });

      const updatedAt = data.saveFamilyHistory.updatedAt;

      this.$set(this.familyHistory, "updatedAt", updatedAt)
    },
    validateForm() {
      this.errors = {};

      if (!this.familyHistory.description?.trim()) {
        this.errors.description = "O H.F. não pode estar vazio.";
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
